import { render, staticRenderFns } from "./GoalTypesTable.vue?vue&type=template&id=dc2bb59e&scoped=true&"
import script from "./GoalTypesTable.vue?vue&type=script&lang=js&"
export * from "./GoalTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2bb59e",
  null
  
)

export default component.exports